// Знак состояния модуля рядом с пунктом навигации.
//
// Один знак на все поверхности (сайдбар, шторка, нижняя навигация) — иначе
// «замок» в одном меню и «серый пункт» в другом читались бы как два разных
// продукта. Пункт при этом ВСЕГДА остаётся кликабельным: страница раздела
// открывается и объясняет ситуацию (`ModuleStateNotice` / `ModuleLockedScreen`),
// а неработающая ссылка ничего не объясняет.

import type { ModuleNavPresentation } from "@studyhub/shared/module";
import { IconAlertTriangle, IconCloudOff, IconLock } from "@tabler/icons-react";

interface ModuleNavMarkerProps {
	presentation: ModuleNavPresentation;
	size?: number;
}

export function ModuleNavMarker({
	presentation,
	size = 12,
}: ModuleNavMarkerProps): React.ReactElement | null {
	if (presentation === "locked") {
		return <IconLock size={size} stroke={1.75} className="shrink-0 text-muted-foreground" />;
	}
	if (presentation === "outage") {
		return <IconAlertTriangle size={size} stroke={1.75} className="shrink-0 text-warning" />;
	}
	if (presentation === "external-outage") {
		return <IconCloudOff size={size} stroke={1.75} className="shrink-0 text-info" />;
	}
	return null;
}

/** Пункт показывается приглушённым — авария, а не обычное состояние. */
export function isDimmedPresentation(presentation: ModuleNavPresentation): boolean {
	return presentation === "outage" || presentation === "external-outage";
}
